// @ flow
import * as React from 'react';

import 'css!./__styles__/RequiredField';
import 'css!bundles/discussions/components/__styles__/NewThreadButton';

const RequiredField = ({ fieldName, inputId }: $TSFixMe) => (
  <label className="c-form-label-area" htmlFor={inputId}>
    <div className="c-form-label headline-1-text">
      <div className="rc-RequiredField">
        {fieldName}
        <span className="required-indicator" aria-hidden="true">
          *
        </span>
      </div>
    </div>
  </label>
);

export default RequiredField;
